import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ShopAnnouncementBar } from '../shop/ShopAnnouncementBar';
import { ShopEdgeTab } from '../shop/ShopEdgeTab';
import OnlineStorePopup from './OnlineStorePopup';
import { Toaster } from 'sonner';

export const Layout = ({ children }) => {
  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();

  // Show the popup every time the homepage is landed on (fresh load or
  // navigated back to), not just once. Hide it immediately if the visitor
  // navigates away from the homepage before the delay fires.
  useEffect(() => {
    if (location.pathname === '/') {
      const timer = window.setTimeout(() => setShowPopup(true), 1500);
      return () => window.clearTimeout(timer);
    } else {
      setShowPopup(false);
    }
  }, [location.pathname]);

  return (
    <div className="page-container">
      <ShopAnnouncementBar />
      <Header />
      <ShopEdgeTab />
      <main className="main-content pt-[100px] md:pt-[116px]">
        {children}
      </main>
      <Footer />
      {showPopup && <OnlineStorePopup onClose={() => setShowPopup(false)} />}
      <Toaster 
        position="top-center" 
        richColors 
        closeButton
        toastOptions={{
          style: {
            fontFamily: 'DM Sans, sans-serif',
          },
        }}
      />
    </div>
  );
};
